export default __webpack_public_path__ + "static/media/rdc.0b6f669c.png";